import { chakra } from '@chakra-ui/react'
import { Checkbox } from '@verbit-ai/verbit-ui-library'

export const FontSizePanel = chakra('div', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 0',
        borderRadius: '3px',
        backgroundColor: theme.palette.fontSizeControl.backgroundColor,

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            top: `calc(${theme.headerHeight}px + 10px)`,
            right: '24px',
            boxShadow: '0px 4px 14px 0px #0000001a',
            padding: '8px 16px',
        },
    }),
})

export const FontSizeOptionList = chakra('ul', {
    baseStyle: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
    },
})

export const FontSizeOptionItem = chakra('li', {})

export const FontSizeOption = chakra('button', {
    baseStyle: ({ theme }) => ({
        /* No longer a flex item of `FontSizePanel` once inside an `<li>`, so without this it shrink-wraps. */
        width: '100%',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
        fontSize: '14px',
        lineHeight: '21px',
        color: theme.palette.fontSizeControl.textColor,

        _hover: {
            backgroundColor: theme.palette.fontSizeControl.optionHoverColor,
        },
    }),
})

export const FullWidthToggleWrapper = chakra('div', {
    baseStyle: ({ theme }) => ({
        padding: '8px 16px',
        borderTop: `1px solid ${theme.palette.fontSizeControl.delimiterColor}`,

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            display: 'none',
        },
    }),
})

export const StyledCheckbox = chakra(Checkbox, {
    baseStyle: ({ theme }) => ({
        display: 'flex !important',

        '& .chakra-checkbox__label': {
            fontSize: '14px',
            lineHeight: '21px',
            marginLeft: '16px',
            color: theme.palette.fontSizeControl.textColor,
        },
    }),
})
